import { useEffect } from 'react';

export function useLogout(logoutApi, onSuccess, onError) {
    useEffect(() => {
        let isMounted = true;

        const logout = async () => {
            try {
                await logoutApi();
                if (isMounted && onSuccess) {
                    onSuccess();
                }
            } catch (err) {
                console.error('logoutApi error', err);
                if (isMounted && onError) {
                    onError(err);
                }
            }
        };

        logout();

        return () => {
            isMounted = false;
        };
    }, [logoutApi, onSuccess, onError]);
}